import { render, staticRenderFns } from "./LikertScale.vue?vue&type=template&id=727facb3&"
import script from "./LikertScale.vue?vue&type=script&lang=js&"
export * from "./LikertScale.vue?vue&type=script&lang=js&"
import style0 from "./LikertScale.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/owiwi.co.uk/staging.appraisal.owiwi.co.uk/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('727facb3', component.options)
    } else {
      api.reload('727facb3', component.options)
    }
    module.hot.accept("./LikertScale.vue?vue&type=template&id=727facb3&", function () {
      api.rerender('727facb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LikertScale/LikertScale.vue"
export default component.exports